import Routing from 'src/routes';

//v.1.0.9
const App = () => {
  return (
    <div
      className="main-container-wrapper-outer"
      style={{ height: '100%', width: '100%' }}
    >
      <Routing />
    </div>
  );
};

export default App;
